<template>
  <div class="project">
    <div class="advan-content" style="width:1200px;margin: 0 auto;text-align: center;min-height: 500px;">
        <div v-html="adDetail">
        </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../style/project-detail.css";
</style>

<script>
  import { mapState } from 'vuex'
  import global from '../components/public/Common.vue';

  export default {
    name: 'author',
    computed: {
      // ...mapState({
      //   author: state => state.AuthorStore.author,
      //   other: state => state.AuthorStore.other,
      //   pathName: state => state.SelectStore.pathName
      // })
    },
    data() {
      return {
        id: '',
        adDetail:{}
      }
    },
    updated:function () {
      //设置图片居中
      $(".advan-content img").css({"display":"block","margin":"10px auto"})
    },
    created: function () {
      let _this = this;
      //_this.$emit('header',false);//控制不显示头部

      _this.id = _this.$route.query.id;
      //查询地区
      $.ajax({
        url: global.serviceUrl+'/',
        type: 'post',
        dataType: 'jsonp',
        data: {token:global.token,'catid':40,"id":_this.id,'orgid':global.orgid},
        success: function (data) {
          if (data.msg == 200) {
            //第一次进页面查询地区
            _this.adDetail = data.result[0].content;
          } else {
            alert(data.msg);
          }
        },
        error: function (data) {

        }
      });
    },
    mounted:function(){
      let _this = this;

    },
    watch: {
      //'$route': 'fetchData'
    },
    methods: {

    },
    filters: {

    },
  }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/Advantage.vue